///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.abcsetup = window.abcsetup || {};
window.modules = window.modules || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.guest = false;
abcsetup.page_name = null;
abcsetup.app_name = null;
abcsetup.blockTimeout = null;
abcsetup.stickyBlock = null;
abcsetup.recaptchaSiteKey = null;

abcsetup.user = null;
abcsetup.userOrg = null;
abcsetup.userRole = null;
abcsetup.userRoles = null;

abcsetup.item = null;
abcsetup.task = null;
abcsetup.performAjaxSilently = false;

abcsetup.ruleSet = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    // Bring the backdrop above all except the current modal (if the model has top-most class)
    $(".modal.top-most").on("shown.bs.modal", function () {
        $('.modal-backdrop.front').removeClass('front');

        if ($(".modal-backdrop").length > 1) {
            $(".modal-backdrop:last").addClass('front');
        }
    });

    // Global tooltips
    $('body').tooltip({
        selector: '.tooltips, .btn[title]:not(.dropdown-toggle, .notips)',
        boundary: 'window',
    });

    // Hide tooltips when clicking on anything
    $(document).on('click', '*', function (e) {
        $('.tooltips, .btn[title]').tooltip('hide');
    });

    // Global popovers
    $.fn.popover.Constructor.Default.whiteList.table = [];
    $.fn.popover.Constructor.Default.whiteList.tr = [];
    $.fn.popover.Constructor.Default.whiteList.td = [];
    $.fn.popover.Constructor.Default.whiteList.th = [];
    $.fn.popover.Constructor.Default.whiteList.div = [];
    $.fn.popover.Constructor.Default.whiteList.thead = [];
    $.fn.popover.Constructor.Default.whiteList.tbody = [];
    $.fn.popover.Constructor.Default.whiteList.ul = [];
    $.fn.popover.Constructor.Default.whiteList.li = [];
    $.fn.popover.Constructor.Default.whiteList.button = [];

    $('body').popover({
        selector: '[data-toggle="popover"]',
        container: 'body',
        html: true,
    });

    // Prevent scrolling when clicking a placeholder link
    $(document).on('click', 'a[href="#"]', function (e) {
        return false;
    });

    // Global collapse
    $(document).on('click', '[data-toggle="collapse"]', function (event) {
        event.preventDefault();
        var target_element = $(this).attr("href");
        $(target_element).collapse('toggle');
        return false;
    });

    // Hide popovers when they're clicked on outside
    // See: https://stackoverflow.com/a/14857326
    $(document).on('click', function (e) {
        $('[data-toggle="popover"],[data-original-title]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide')
            }
        });
    });

    // Load global values
    abcsetup.guest = !!parseInt($('#globals').find('#guest').val());
    abcsetup.page_name = $('#globals').find('#page_name').val().replace('-', '');
    abcsetup.app_name = $(document).prop('title');
    abcsetup.recaptchaSiteKey = $('#globals').find('#recaptcha_sitekey').val();

    if (!abcsetup.guest) {
        //abcsetup.userOrg = $('#globals').find('#user-org').val() ? JSON.parse($('#globals').find('#user-org').val()) : null;
        //abcsetup.userRole = $('#globals').find('#user-role').val() ? JSON.parse($('#globals').find('#user-role').val()) : null;
        //abcsetup.userRoles = $('#globals').find('#user-roles').val() ? JSON.parse($('#globals').find('#user-roles').val()) : null;

        abcsetup.user = JSON.parse($('#globals').find('#user').val());
        abcsetup.userOrg = JSON.parse($('#globals').find('#user-org').val());
        abcsetup.userRole = JSON.parse($('#globals').find('#user-role').val());
        abcsetup.userRoles = JSON.parse($('#globals').find('#user-roles').val());
        abcsetup.orgOneWs = JSON.parse($('#globals').find('#org-1ws').val());
        abcsetup.ruleSet = $('#globals').find('#rule_set').val();
    }

    abcsetup.init();
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global ABCSetup Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.abcsetup = {
    init: function () {
        // Bind all axios/jquery ajax events and block the UI/submit buttons when doing so
        // Default to true if the user is not logged in
        abcsetup.performAjaxSilently = abcsetup.guest;

        // Bind all axios/jquery ajax events
        this.bindAjax();

        // Load the route specific JS
        this.loadRouteJS();

        // Determine if sticky elems are sticking
        $(window).on('resize scroll load', function () {
            $('.sticky-top').each(function () {
                var isStuck = $(this)[0].getBoundingClientRect().top <= parseInt($(this).css('top'), 10);
                $(this).toggleClass('sticking', isStuck);
            });

            $('.sticky-bottom').each(function () {
                var isStuck = $(this)[0].getBoundingClientRect().bottom + parseInt($(this).css('bottom'), 10) >= window.innerHeight;
                $(this).toggleClass('sticking', isStuck);
            });
        });

        // ekko-lightbox
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox();
        });

        // Prevent clicking on readonly checkboxes
        $(document).on('click', ':checkbox[readonly]', function(event) {
            return false;
        });

        // Table toggler
        $(document).on('click', '.btn-group-toggle[data-target]', function () {
            const val = $(this).find('input[type=radio]:checked').val()
            $('div.' + $(this).data('target')).hide();
            $('div.' + $(this).data('target') + '.' + val).show()
                // Trigger the resize event for any datatables
                .find('table.datatable').trigger('resize');
        });

        // Bind expanding datatables
        this.bindExpandingDataTables();
    },


    /**
     * Bind all axios/jquery ajax events
     */
    bindAjax: function () {
        // Bind all jQuery ajax requests ----------------------------------------------------------
        // Global ajax start event
        $(document).ajaxStart(function () {
            if (!abcsetup.performAjaxSilently) {
                abcsetup.blockUI();
                //abcsetup.blockUI(true);

                // Set a timeout and show the progress wheel after a 1.5 seconds
                abcsetup.blockTimeout = setTimeout(function () {
                    abcsetup.blockUI(true);
                }, 1500);
            }
        });

        // Global ajax send event
        $(document).ajaxSend(function (elm, xhr, s) {
            if (s.type == "POST") {
                var token = document.head.querySelector('meta[name="csrf-token"]');
                xhr.setRequestHeader('X-CSRF-Token', token.content);
            }
        });

        // Global ajax complete event
        $(document).ajaxComplete(function () {
            // It's the last ajax request in process
            if ($.active == 1) {
                abcsetup.unblockUI();
            }
        });
        // ----------------------------------------------------------------------------------------


        // Bind all axios requests ----------------------------------------------------------------
        axios.interceptors.request.use((config) => {
            if (!abcsetup.performAjaxSilently) {
                //$('.is-invalid').removeClass('is-invalid');
                $(':input[type="submit"]').not('.manual-disabled').prop('disabled', true).addClass('disabled');
            }

            return config;
        });

        // Bind all axios responses
        axios.interceptors.response.use(function(response) {
            if (!abcsetup.performAjaxSilently) {
                $(':input[type="submit"]').not('.manual-disabled').prop('disabled', false).removeClass('disabled');
                $('.btn.auto-disabled').removeClass('disabled auto-disabled').attr('disabled', false);
            }

            // Regen any reCAPTCHA tokens
            abcsetup.recaptcha.generate();

            return response;

        }, function(error) {
            if (!abcsetup.performAjaxSilently) {
                $(':input[type="submit"]').not('.manual-disabled').prop('disabled', false).removeClass('disabled');
                $('.btn.auto-disabled').removeClass('disabled auto-disabled').attr('disabled', false);
            }

            // Unauthorized
            /*
            if (error.response.status === 401 && auth.check()) {
                auth.logout();
                window.location.href = '/';

            } else {
                abcsetup.alerts.showErrors(error.response.data);
            }
            */

            if (!abcsetup.performAjaxSilently) {
                // Regen any reCAPTCHA tokens
                abcsetup.recaptcha.generate();

                // Show the error message(s)
                abcsetup.alerts.showErrors(error.response.data);
            }

            return Promise.reject(error);
        });
        // ----------------------------------------------------------------------------------------
    },

    /**
     * Bind expanding datatables
     */
    bindExpandingDataTables: function() {
        // Bind expanding datatables
        $(document).on("click", ".expand-table", function() {
            const tableId = $(this).closest('table').attr('id');
            const table = window.LaravelDataTables[tableId];
            const expandData = $('#expand_' + $(this).data('id'));

            $(this).find('i.fa').toggleClass('fa-plus-square fa-minus-square');
            const tr = $(this).closest('tr');
            const row = table.row(tr);

            // This row is already open - close it
            if (row.child.isShown()) {
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Add the match table to the row as a child
                row.child(expandData.html(), 'shown-child').show();
                tr.addClass('shown');
            }
        });
    },

    /**
     * Load the route specific JS
     */
    loadRouteJS: function(functionName = 'init', callBack = null) {
        // Support to handle generic/module route js
        $(['window.abcsetup.', 'window.modules.']).each(function(key, prefix) {
            const namespace = [];
            let find = '';

            $(abcsetup.page_name.split('.')).each(function () {
                if (namespace.length) {
                    namespace.push(namespace[namespace.length - 1] + '.' + this);
                } else {
                    namespace.push(this);
                }

                find += prefix + namespace[namespace.length - 1] + ' && ';
            });

            find = find.trim();
            find = find ? find.substring(0, find.length - 2).trim() : '';

            console.log('Init route JS: ' + abcsetup.page_name + '.' + functionName);
            eval('if (' + find + ' && ' + prefix + abcsetup.page_name + '.' + functionName + ') { console.log(\' +Found: ' + abcsetup.page_name + '.' + functionName + '\'); ' + prefix + abcsetup.page_name + '.' + functionName + '("' + callBack + '"); }');
        });
    },


    /**
     * Set the page title
     */
    setTitle: function (title) {
        //$(document).prop('title', abcsetup.app_name + ' — ' + title);
        $(document).prop('title', abcsetup.app_name + ' - ' + title);
    },


    /**
     * Reload the main app
     */
    reload: function () {
        window.location.href = '/';
    },


    /**
     * Block the UI, optionally show a progress wheel
     */
    blockUI: function (show = false, sticky = false) {
        $('#blocker').addClass('on');
        abcsetup.stickyBlock = sticky;

        if (show) {
            $('#blocker').addClass('progress');
        }
    },


    /**
     * Unblock the UI
     */
    unblockUI: function () {
        if (!abcsetup.stickyBlock) {
            $('#blocker').removeClass('on progress');
        }

        clearTimeout(abcsetup.blockTimeout);
    },


    /**
     * Generate a random string
     */
    randomString: function () {
        return Math.random().toString(36).substr(2, 18);
    },


    /**
     * Get a URL request param
     *
     * @param {*} sParam
     */
    getUrlParameter: function (sParam) {
        var tmpReturn = [];
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sURLVariables[i] = decodeURIComponent(sURLVariables[i]);
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                tmpReturn.push(sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]));
            }
        }

        if (tmpReturn.length === 0) {
            return null;
        }

        return tmpReturn;
    },

    /**
     * Replace a param's value with a new one in a url.
     *
     * @param param
     * @param newValue
     * @param {string|null} url We'll use the current location if no URL is given.
     */
    replaceUrlParameter: function (param, newValue, url = null) {
        // The URL and URLSearchParams classes are not supported in IE, but we can support it with core-js via Babel's https://babeljs.io/docs/en/babel-preset-env in babel-loader https://webpack.js.org/loaders/babel-loader/.
        const Url = new URL(url || window.location);
        const UrlParams = Url.searchParams;
        UrlParams.set(param, newValue);

        return Url.origin + Url.pathname + '?' + UrlParams.toString();
    },


    /**
     *
     * @param {*} str
     * @param {*} term
     * @param {*} replacement
     */
    replaceAll: function (str, term, replacement) {
        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }

        return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
    },


    /**
     * Launch a popup window with the specific params
     *
     * @param {*} url
     * @param {*} params
     */
    launchWin: function (url, name = null, params = null) {
        var width = $(window).width() * .75;
        var height = $(window).height() * .75;
        var left = ($(window).width() / 2) - (width / 2);
        var top = ($(window).height() / 2) - (height / 2);

        params = params ? params : 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;
        window.open(url, name, params);
    },

    /**
     * Format val into a number with commas
     * @param {*} val
     */
    addCommas: function (val) {
        val = val + ''; // Convert val to a string
        return val.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },

    /**
     *
     * @param {*} phrase
     */
    indefiniteArticle: function (phrase) {
        // Getting the first word
        var match = /\w+/.exec(phrase);
        if (match) {
            var word = match[0];
        } else {
            return "an";
        }

        var l_word = word.toLowerCase();

        // Specific start of words that should be preceeded by 'an'
        var alt_cases = ["honest", "hour", "hono"];
        for (var i in alt_cases) {
            if (l_word.indexOf(alt_cases[i]) == 0) {
                return "an";
            }
        }

        // Single letter word which should be preceeded by 'an'
        if (l_word.length == 1) {
            if ("aedhilmnorsx".indexOf(l_word) >= 0) {
                return "an";
            } else {
                return "a";
            }
        }

        // Capital words which should likely be preceeded by 'an'
        if (word.match(/(?!FJO|[HLMNS]Y.|RY[EO]|SQU|(F[LR]?|[HL]|MN?|N|RH?|S[CHKLMNPTVW]?|X(YL)?)[AEIOU])[FHLMNRSX][A-Z]/)) {
            return "an";
        }

        // Special cases where a word that begins with a vowel should be preceeded by 'a'
        regexes = [/^e[uw]/, /^onc?e\b/, /^uni([^nmd]|mo)/, /^u[bcfhjkqrst][aeiou]/]
        for (var i in regexes) {
            if (l_word.match(regexes[i])) {
                return "a"
            }
        }

        // Special capital words (UK, UN)
        if (word.match(/^U[NK][AIEO]/)) {
            return "a";
        } else if (word == word.toUpperCase()) {
            if ("aedhilmnorsx".indexOf(l_word[0]) >= 0) {
                return "an";
            } else {
                return "a";
            }
        }

        // Basic method of words that begin with a vowel being preceeded by 'an'
        if ("aeiou".indexOf(l_word[0]) >= 0) {
            return "an";
        }

        // Instances where y follwed by specific letters is preceeded by 'an'
        if (l_word.match(/^y(b[lor]|cl[ea]|fere|gg|p[ios]|rou|tt)/)) {
            return "an";
        }

        return "a";
    },

    debounce: function(func, wait, immediate) {
        // https://davidwalsh.name/javascript-debounce-function
        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    /**
     *
     */
    scrollIntoView: function(element, container) {
        clearTimeout(abcsetup.scroll_timeout);

        abcsetup.scroll_timeout = setTimeout(function() {
            console.log(element.offsetTop);
            var containerTop = $(container).scrollTop();
            var containerBottom = containerTop + $(container).height();
            var scrollTop = element.offsetTop;
            var scrollLeft = element.offsetLeft;
            var elemBottom = scrollTop + $(element).height();

            if (elemBottom > containerBottom) {
                scrollTop = elemBottom - $(container).height();
            }

            $(container).animate({scrollTop : scrollTop },500);
            $(container).animate({scrollLeft : scrollLeft },500);
        }, 250);
    },

    /*
     * change the requirement prop of an element
     */
    toggleRequired: function(element, to = null) {
        element.required = (to ?? !element.prop('required'));
    },

    /**
     *  @param jquery element
     */
    acceptNumbersOnly: function(element) {
        element.bind({
            keydown: function(e) {
                if (e.shiftKey === true ) {
                    if (e.which == 9) {
                        return true;
                    }
                    return false;
                }
                if (e.which > 57) {
                    return false;
                }
                if (e.which==32) {
                    return false;
                }
                return true;
            }
        });
    },

    /**
     *  @param jquery element
     *  @param integer decimals
     */
    forceDecimal(element, decimals) {
        if (typeof decimals === 'undefined' || isNaN(parseInt(decimals, 10))) {
            decimals = 2;
        }

        element.on('change', e => {
            e.target.value = parseFloat(e.target.value).toFixed(decimals);
        });
    },

    handleSignaturePad: function(canvas, context) {
        const imageData = context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
        );

        const data = imageData.data;
        let filledPixels = 0;

        for (let i = 0; i < data.length; i += 4) {
            // Check if the alpha channel is non-zero (pixel is not transparent)
            if (data[i + 3] !== 0) {
                filledPixels++;
            }
        }

        const totalPixels = canvas.width * canvas.height;
        const filledPercentage = (filledPixels / totalPixels) * 100;

        return filledPercentage.toFixed(2);
    },

    validateSignaturePad: function(canvasId, msg) {
        let filledPercentage = abcsetup.handleSignaturePad($('#'+canvasId)[0], $('#'+canvasId)[0].getContext('2d'));
        let valid = filledPercentage >= Number(0.50).toFixed(2);

        if (!$('#'+canvasId+'-alert').length) {
            $('#'+canvasId).after('<small id="'+canvasId+'-alert" class="signature-pad-alert d-none">'+msg+'</small>');
        }

        $('#'+canvasId+'-alert').toggleClass('d-none', valid)

        return valid;
    },

    sleep: function(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
